import React from "react";
import { $t } from '@/modules/i18n';

class Navbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: this.props.lang,
    };

  }
  handleChange(e) {
    this.setState({
      lang: e.target.value,
    })
  }
  render() {
    const { isSG, Message: msg } = this.props;
    return (
      <nav className="navbar navbar-default navbar-expand-lg fixed-top">
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown"
          aria-expanded="false" aria-label="Toggle navigation">
          <span className="icon ios-arrow-up"></span>
        </button>
        <div className="nav-logo-mobile">
          <img src={require('@ndsc/assets/images/logo_shopee_v.png')} alt="Company Logo" />
          <h1 className="logo-text">National<br />Data Science<br />Challenge</h1>
        </div>
        <div className="collapse navbar-collapse" id="navbarNavDropdown">
          <div className="container">
            <a className="nav-logo-desktop" href="/">
              { isSG
                ? <span className="logo">
                    <img src={require("@ndsc/assets/images/logo_shopee_h.png")} alt="Company Logo" />
                  </span>
                : null }
              <h1 className="logo-text">National<br />Data Science<br />Challenge</h1>
            </a>
            <ul className="navbar-nav ml-auto" data-easing="easeInOutExpo" data-speed="1250" data-offset="65">
              {
                (msg.navbar || []).map(item => (
                  <li className="nav-item" key={item.name}>
                    <a className={`nav-link ${item.class || ''}`} href={item.href || item.link} target={item.href ? "_self" : "_blank"} rel="noopener noreferrer">{$t(item.name)}</a>
                  </li>
                ))
              }
              {
                !isSG
                ? <li className="nav-item">
                  <div className="nav-link">
                    <img src={require('@ndsc/assets/images/icon_lang.svg')} alt="select language" className="icon-lang" />
                    <select name="" id="lang" onChange={e => this.props.onInputChange(e.target.value)} defaultValue={this.props.value} className="select-lang">
                      <option value='id'>ID</option>
                      <option value='en'>EN</option>
                    </select>
                  </div>
                </li>
                : null
              }
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}

export default Navbar;